import { ComponentF } from "../../../ui/ui";
import { gameData, sortPlayerLetters } from "../../GameManager";
import { buildLetterStringPieces } from "../words/WordUIHelpers";

export const FLOURISH_WIDTH = 8;

export const SpellWand: ComponentF<{ static: string }> = (C, props) => {
  const letters = gameData.player.spellWand;

  const center = Math.floor(
    C.bounds.w / 2 -
      ((props.static?.length || gameData.player.maxLetters) + FLOURISH_WIDTH) /
        2
  );
  C.display.drawText(
    C.bounds.x + center,
    C.bounds.y,
    `===[${
      props.static ||
      buildLetterStringPieces(
        letters,
        gameData.letters,
        gameData.player.maxLetters
      )
    }]===`
  );

  C.handlers.keypress = (key: string) => {
    if (key === "~" || key === "`") {
      sortPlayerLetters();
      return true;
    }
    return false;
  };

  C.handlers.press = () => {
    sortPlayerLetters();
  };
};
